// extracted by mini-css-extract-plugin
module.exports = {"slider":"CustomSlider_slider__2Ozmy","slick-next":"CustomSlider_slick-next__X2CWF"};